var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("split-wrapper", { staticClass: "product-ts" }, [
    _c(
      "div",
      {
        staticClass: "product-ts__image-container",
        attrs: { slot: "image" },
        slot: "image"
      },
      [
        _vm.customFields["5050_image"]
          ? _c("img", {
              staticClass: "product-ts__image",
              attrs: {
                src: _vm.imageCrop(
                  _vm.imageSize(_vm.customFields["5050_image"], "640x480"),
                  "center"
                ),
                alt: _vm.customFields["5050_header"]
              }
            })
          : _vm._e()
      ]
    ),
    _c(
      "article",
      {
        staticClass: "product-ts__main",
        attrs: { slot: "content" },
        slot: "content"
      },
      [
        _c("div", { staticClass: "product-ts__main-wrap" }, [
          _c("h2", { staticClass: "h3 product-ts__header" }, [
            _vm._v(_vm._s(_vm.customFields["5050_header"]))
          ]),
          _c("div", {
            staticClass: "product-ts__text-copy client-generated",
            domProps: { innerHTML: _vm._s(_vm.customFields["5050_body_copy"]) }
          }),
          _vm.customFields["5050_show_table"]
            ? _c(
                "table",
                { staticClass: "product-ts__table" },
                _vm._l(_vm.splitTableHeading, function(item, index) {
                  return _c("tr", { staticClass: "product-ts__table-row" }, [
                    _c("td", { staticClass: "product-ts__table-heading h7" }, [
                      _vm._v(_vm._s(item) + " ")
                    ]),
                    _c(
                      "td",
                      { staticClass: "product-ts__table-data body-sm" },
                      [_vm._v(_vm._s(_vm.splitTableData[index]))]
                    )
                  ])
                }),
                0
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "product-ts__links" },
            [
              _vm.customFields["5050_link_url"] &&
              _vm.customFields["5050_link_text"]
                ? _c(
                    "v-link",
                    {
                      staticClass: "product-ts__text-link",
                      attrs: {
                        secondary: "",
                        href: _vm.customFields["5050_link_url"]
                      }
                    },
                    [_vm._v(_vm._s(_vm.customFields["5050_link_text"]))]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }